import Module from "./apps/SmartControlModule.svelte";
import { mount } from "svelte";
// import { worker } from "./mocks/browser"
// const { worker } = import "./mocks/browser")
// worker.start()
window.SmartControlModule = function (options) {
    return mount(Module, options);
};
